module.exports = __webpack_public_path__ + "static/media/frameWrong.8d90b124.png";